import styled from 'styled-components';

export type SortDirection = 'asc' | 'desc' | null;

// Conteneur empilant les deux chevrons (haut/bas) en petit, pour matcher la
// proportion des autres flèches de l'app. Le chevron de la direction active est
// en couleur secondaire ; les chevrons inactifs sont atténués (gris).
export const SSortIcon = styled.span<{ $direction: SortDirection }>`
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 0.4rem;
    line-height: 0;
    vertical-align: middle;

    svg {
        display: block;
        width: 1rem;
        height: 1rem;
    }

    /* Rapproche les deux chevrons (le viewBox 24x24 a beaucoup de marge interne). */
    .sort-down {
        margin-top: -0.45rem;
    }

    .sort-up path {
        fill: ${({ theme, $direction }) =>
            $direction === 'asc' ? theme.color.secondary.main : theme.color.grey.light};
    }

    .sort-down path {
        fill: ${({ theme, $direction }) =>
            $direction === 'desc' ? theme.color.secondary.main : theme.color.grey.light};
    }
`;
